var render = function render(){
  var _vm$value, _vm$value2, _vm$value2$form;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "rounded": "lg",
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "min-w-md-200px min-w-lg-280px",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('item-company', _vm._b({}, 'item-company', {
    value: _vm.value
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('h5', {
    staticClass: "page-text--lg font-weight-medium"
  }, [_c('span', [_vm._v(" " + _vm._s((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value.subject) + " ")]), _c('span', {
    staticClass: "page-text--sm"
  }, [_vm._v(" (" + _vm._s((_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : (_vm$value2$form = _vm$value2.form) === null || _vm$value2$form === void 0 ? void 0 : _vm$value2$form.name) + ") ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_vm.value.isSigned ? [_c('v-chip', {
    attrs: {
      "label": "",
      "color": "primary"
    }
  }, [_c('v-icon', {
    staticClass: "ml-4",
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-check")]), _c('span', [_vm._v(" 서명완료 ")])], 1)] : [_c('v-chip', {
    attrs: {
      "label": "",
      "color": "grey-ec",
      "text-color": "grey-1"
    }
  }, [_c('v-icon', {
    staticClass: "mr-4",
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-minus")]), _c('span', [_vm._v(" 서명대기 ")])], 1)]], 2)], 1)], 1)], 1)], 1), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('item-meta', _vm._b({}, 'item-meta', {
    value: _vm.value
  }, false))], 1), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_vm.value.isSigned ? [_c('employment-contract-view', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "outlined": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v(" 자세히 보기 ")])])];
      }
    }], null, false, 2269495756)
  }, 'employment-contract-view', {
    value: _vm.value
  }, false))] : [_c('employment-contract-sign', _vm._g(_vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "outlined": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v(" 서명하기 ")])])];
      }
    }])
  }, 'employment-contract-sign', {
    value: _vm.value
  }, false), {
    search: _vm.search
  }))]], 2)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }